import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGrenada = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_29_363)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.23655 2.08697C7.1624 0.770437 9.49106 0 12 0C14.5089 0 16.8376 0.770437 18.7634 2.08697L12 2.60869L5.23655 2.08697Z",
				fill: "#A2001D"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12 12L11.2342 11.2342L11.0308 11.5984L12 12Z",
				fill: "#0052B4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3.51469 3.51469C-1.17159 8.20097 -1.17159 15.799 3.51469 20.4853C5.45123 18.5488 7.31372 16.6863 12 12L3.51469 3.51469Z",
				fill: "#496E2D"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M20.4853 3.51469C25.1716 8.20097 25.1716 15.799 20.4853 20.4853C18.5488 18.5488 16.6863 16.6863 12 12L20.4853 3.51469Z",
				fill: "#496E2D"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12 16.1739C14.3052 16.1739 16.1739 14.3052 16.1739 12C16.1739 9.69482 14.3052 7.82611 12 7.82611C9.69482 7.82611 7.82611 9.69482 7.82611 12C7.82611 14.3052 9.69482 16.1739 12 16.1739Z",
				fill: "#A2001D"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12 7.82611L12.9355 10.7056H15.9636L13.514 12.4856L14.4495 15.3652L12 13.5855L9.55027 15.3652L10.486 12.4856L8.03644 10.7056H11.0643L12 7.82611Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12 0C11.9986 0 11.9973 0.000125 11.996 0.000125H12.004C12.0027 0.000125 12.0014 0 12 0Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12.004 0H11.996C8.68415 0.00107812 5.68598 1.34372 3.51534 3.51413H20.4847C18.314 1.34372 15.3158 0.00107812 12.004 0Z",
				fill: "#A2001D"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3.51539 20.4859C5.68692 22.6571 8.68664 24 12 24C15.3134 24 18.3131 22.6571 20.4846 20.4859H3.51539Z",
				fill: "#A2001D"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12 1.30434L12.1943 1.90219H12.8229L12.3143 2.2717L12.5086 2.86955L12 2.50008L11.4915 2.86955L11.6857 2.2717L11.1771 1.90219H11.8057L12 1.30434Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.09014 1.30434L9.28443 1.90219H9.91303L9.40448 2.2717L9.59878 2.86955L9.09014 2.50008L8.58164 2.86955L8.77589 2.2717L8.26725 1.90219H8.89584L9.09014 1.30434Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M14.9099 1.30434L15.1042 1.90219H15.7327L15.2242 2.2717L15.4185 2.86955L14.9099 2.50008L14.4013 2.86955L14.5956 2.2717L14.087 1.90219H14.7156L14.9099 1.30434Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12 21.1305L12.1943 21.7283H12.8229L12.3143 22.0978L12.5086 22.6957L12 22.3261L11.4915 22.6957L11.6857 22.0978L11.1771 21.7283H11.8057L12 21.1305Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.09014 21.1305L9.28443 21.7283H9.91303L9.40448 22.0978L9.59878 22.6957L9.09014 22.3261L8.58164 22.6957L8.77589 22.0978L8.26725 21.7283H8.89584L9.09014 21.1305Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M14.9099 21.1305L15.1042 21.7283H15.7327L15.2242 22.0978L15.4185 22.6957L14.9099 22.3261L14.4013 22.6957L14.5956 22.0978L14.087 21.7283H14.7156L14.9099 21.1305Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3.65639 11.8018C3.9646 12.2888 3.81975 12.9334 3.33277 13.2416C2.84583 13.5499 2.2012 13.405 1.89295 12.918C1.33491 12.0364 1.65848 10.5966 1.65848 10.5966C1.65848 10.5966 3.0983 10.9201 3.65639 11.8018Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3.05372 13.3226C3.34186 13.3226 3.57544 13.089 3.57544 12.8009C3.57544 12.5127 3.34186 12.2791 3.05372 12.2791C2.76558 12.2791 2.532 12.5127 2.532 12.8009C2.532 13.089 2.76558 13.3226 3.05372 13.3226Z",
				fill: "#A2001D"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_29_363",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgGrenada;
